export default "__VITE_ASSET__DkR3MknP__"